import React from 'react'
import { Grid } from '@material-ui/core'
import { GridItem } from './grid-item'

export const GridItemsWrapper = ({
    floorPlanDevices,
    onMoveDevice,
    setActiveBlur,
    isMobile,
    handleClose
}) => {
    const handleMoveDevice = device => {
        onMoveDevice(
            device.hasOwnProperty('router_type'),
            device.id,
            null,
            null
        )
        handleClose()
    }
    return (
        <Grid container>
            {floorPlanDevices?.map((item, index) => (
                <GridItem
                    key={index}
                    floorPlanDevice={item}
                    onClick={() => (isMobile ? handleMoveDevice(item) : null)}
                    setActiveBlur={setActiveBlur}
                    isMobile={isMobile}
                />
            ))}
        </Grid>
    )
}
